import React from "react";
import styles from "./index.module.scss";
export default function VaultTag({
  status,
  isLocked,
  isWhite = false
}: {
  status: string | null;
  isLocked: boolean;
  isWhite?: boolean;
}) {
  return (
    <>
      {status !== null && (
        <div
          className={`${styles.VaultTag} ${
            styles[status?.replaceAll(" ", "")]
          }`}
        >
          {isLocked && !isWhite && <img src="/images/lock.svg" alt="" />}
          {status === "CHECK OUT" && <img src="/images/lock-white.svg" alt="" />}
          {isWhite && isLocked && <img src="/images/lock-white.svg" alt="" />}
          {status === "CHECK OUT" ? "CHECKED OUT" : status === "BID PLACE" ? "BID PLACED" : status}
        </div>
      )}
    </>
  );
}
